export const translations = {
  en: {
    nav: {
      home: "Home",
      browse: "Browse",
      interests: "Interests",
      chat: "Chat",
      profile: "Profile",
      kundli: "Kundli",
      premium: "Premium",
      admin: "Admin",
      logout: "Logout",
      login: "Login",
      register: "Register Free",
      phoneOtp: "Phone OTP",
    },
    landing: {
      heroTitle: "Find Your Perfect Life Partner",
      heroSubtitle: "Hamarsathi — the most trusted matrimony platform made only for Jharkhand. Search by district & block, express interest, and find your forever match.",
      ctaRegister: "Register Free",
      ctaLogin: "Login",
      ctaInstall: "Install App Now",
      whyTitle: "Why Choose Hamarsathi?",
      whySubtitle: "Designed specifically to help the people of Jharkhand find meaningful connections locally.",
      featVerifyTitle: "Verified Profiles",
      featVerifyDesc: "We ensure trust and safety by verifying profiles with government ID verification checked by admins.",
      featLocalTitle: "District & Block Filters",
      featLocalDesc: "Narrow down your searches to specific districts, blocks, and villages in Jharkhand for closer matches.",
      featMatchTitle: "Mutual Interest Unlock",
      featMatchDesc: "Contact details are kept private and only unlocked when both users accept each other's interest.",
      featKundliTitle: "Free Kundli Matching",
      featKundliDesc: "Calculate birth charts and match Gunas instantly to find spiritually compatible partners.",
      statsTitle: "Connecting Hearts Across Jharkhand",
      statsMembers: "Active Members",
      statsSuccess: "Happy Matches",
      statsDistricts: "Districts Covered",
      statsSecurity: "Verified Security",
      downloadTitle: "Download the Hamarsathi App",
      downloadDesc: "Install Hamarsathi on your home screen for instant updates, real-time alerts, and a faster partner search.",
      footerDesc: "Hamarsathi is one of the leading and most trusted matrimony platforms in Jharkhand, helping you find happy marriages locally.",
      footerNotice: "Hamarsathi is meant only for users with a bonafide intent to enter into a matrimonial alliance.",
      copyright: "Hamarsathi. All rights reserved.",
    },
    auth: {
      loginTitle: "Login to Hamarsathi",
      loginSubtitle: "Enter your credentials to find your match",
      email: "Email Address",
      password: "Password",
      btnLogIn: "Log In",
      tryDemo: "Try demo:",
      noAccount: "Don't have an account?",
      registerNow: "Register now",
      phoneLoginBtn: "Sign in with Phone Number",
      orSeparator: "OR",
      registerTitle: "Create your Hamarsathi Account",
      registerSubtitle: "Start your journey to find your life partner",
      fullName: "Full Name",
      gender: "Gender",
      male: "Male",
      female: "Female",
      alreadyRegistered: "Already registered?",
      logInNow: "Log in now",
      btnRegister: "Register & Continue",
      phoneLoginTitle: "Phone OTP Login",
      phoneLoginSubtitle: "Login using your registered mobile number",
      phoneNumber: "Phone Number",
      sendOtp: "Send OTP",
      verifyOtpTitle: "Verify Your Account",
      verifyOtpSubtitle: "We have sent a 6-digit OTP code to your registered details.",
      otpCode: "6-Digit OTP Code",
      btnVerify: "Verify & Log In",
      resendOtp: "Resend OTP",
      resendWait: "Resend in {seconds}s",
    },
    dashboard: {
      welcome: "Welcome back,",
      completion: "Profile Completion",
      completeProfile: "Complete Profile",
      metrics: {
        views: "Profile Views",
        recInterests: "Received Interests",
        sentInterests: "Sent Interests",
        matches: "Mutual Matches",
      },
      referralTitle: "Invite Friends & Earn Rewards",
      referralDesc: "Share your referral link with friends and unlock premium features when they complete their profiles.",
      refCode: "Your Referral Code",
      shareWhatsapp: "Share on WhatsApp",
      points: "Points",
      rank: "Rank",
      notifications: "Recent Updates",
      markAllRead: "Mark all as read",
      noNotifications: "No new notifications",
    }
  },
  hi: {
    nav: {
      home: "मुख्य पृष्ठ",
      browse: "सर्च करें",
      interests: "रुचियां",
      chat: "चैट",
      profile: "प्रोफाइल",
      kundli: "कुंडली मिलान",
      premium: "प्रीमियम",
      admin: "एडमिन",
      logout: "लॉगआउट",
      login: "लॉगिन",
      register: "मुफ्त पंजीकरण",
      phoneOtp: "फोन ओटीपी",
    },
    landing: {
      heroTitle: "अपना आदर्श जीवनसाथी खोजें",
      heroSubtitle: "हमरसाथी — झारखंड के लोगों के लिए विशेष रूप से बनाया गया सबसे भरोसेमंद विवाह मंच। जिला और ब्लॉक के आधार पर खोजें, रुचि व्यक्त करें और अपना हमसफर पाएं।",
      ctaRegister: "मुफ्त पंजीकरण करें",
      ctaLogin: "लॉगिन करें",
      ctaInstall: "अभी ऐप इंस्टॉल करें",
      whyTitle: "हमरसाथी को क्यों चुनें?",
      whySubtitle: "विशेष रूप से झारखंड के लोगों को उनके आस-पास सार्थक संबंध खोजने में मदद करने के लिए डिज़ाइन किया गया है।",
      featVerifyTitle: "सत्यापित प्रोफाइल",
      featVerifyDesc: "हम एडमिन द्वारा सरकारी पहचान पत्र सत्यापन के माध्यम से सुरक्षा और विश्वसनीयता सुनिश्चित करते हैं।",
      featLocalTitle: "जिला और ब्लॉक फिल्टर",
      featLocalDesc: "झारखंड में अपने आस-पास के सटीक मिलान के लिए अपनी खोज को विशिष्ट जिलों, ब्लॉकों और गांवों तक सीमित करें।",
      featMatchTitle: "परस्पर स्वीकृति पर संपर्क अनलॉक",
      featMatchDesc: "संपर्क विवरण सुरक्षित रखे जाते हैं और केवल तभी अनलॉक होते हैं जब दोनों उपयोगकर्ता एक-दूसरे की रुचि स्वीकार करते हैं।",
      featKundliTitle: "मुफ्त कुंडली मिलान",
      featKundliDesc: "अध्यात्मिक रूप से अनुकूल जीवनसाथी खोजने के लिए जन्म कुंडली की गणना करें और तुरंत गुण मिलान करें।",
      statsTitle: "झारखंड में दिलों को जोड़ना",
      statsMembers: "सक्रिय सदस्य",
      statsSuccess: "सफल शादियां",
      statsDistricts: "कवर किए गए जिले",
      statsSecurity: "सत्यापित सुरक्षा",
      downloadTitle: "हमरसाथी ऐप डाउनलोड करें",
      downloadDesc: "त्वरित अपडेट, रीयल-टाइम अलर्ट और तेजी से पार्टनर सर्च के लिए हमरसाथी को अपनी होम स्क्रीन पर इंस्टॉल करें।",
      footerDesc: "हमरसाथी झारखंड के अग्रणी और सबसे भरोसेमंद वैवाहिक मंचों में से एक है, जो आपको स्थानीय रूप से खुशहाल विवाह खोजने में मदद करता।",
      footerNotice: "हमरसाथी का उद्देश्य केवल वास्तविक रूप से वैवाहिक गठबंधन में प्रवेश करने की मंशा रखने वाले उपयोगकर्ताओं के लिए है।",
      copyright: "हमरसाथी। सर्वाधिकार सुरक्षित।",
    },
    auth: {
      loginTitle: "हमरसाथी में लॉगिन करें",
      loginSubtitle: "अपना जीवनसाथी खोजने के लिए अपना विवरण दर्ज करें",
      email: "ईमेल एड्रेस",
      password: "पासवर्ड",
      btnLogIn: "लॉग इन करें",
      tryDemo: "डेमो आज़माएं:",
      noAccount: "खाता नहीं है?",
      registerNow: "अभी पंजीकरण करें",
      phoneLoginBtn: "फोन नंबर से लॉगिन करें",
      orSeparator: "या",
      registerTitle: "अपना हमरसाथी खाता बनाएं",
      registerSubtitle: "अपना जीवनसाथी खोजने की अपनी यात्रा शुरू करें",
      fullName: "पूरा नाम",
      gender: "लिंग",
      male: "पुरुष",
      female: "महिला",
      alreadyRegistered: "पहले से पंजीकृत हैं?",
      logInNow: "अभी लॉगिन करें",
      btnRegister: "पंजीकरण करें और आगे बढ़ें",
      phoneLoginTitle: "फोन ओटीपी लॉगिन",
      phoneLoginSubtitle: "अपने पंजीकृत मोबाइल नंबर का उपयोग करके लॉगिन करें",
      phoneNumber: "फ़ोन नंबर",
      sendOtp: "ओटीपी भेजें",
      verifyOtpTitle: "अपना खाता सत्यापित करें",
      verifyOtpSubtitle: "हमने आपके पंजीकृत विवरण पर 6 अंकों का ओटीपी कोड भेजा है।",
      otpCode: "6 अंकों का ओटीपी कोड",
      btnVerify: "सत्यापित करें और लॉगिन करें",
      resendOtp: "ओटीपी दोबारा भेजें",
      resendWait: "{seconds} सेकंड में पुनः भेजें",
    },
    dashboard: {
      welcome: "आपका स्वागत है,",
      completion: "प्रोफाइल पूर्णता",
      completeProfile: "प्रोफाइल पूरी करें",
      metrics: {
        views: "प्रोफाइल दर्शक",
        recInterests: "प्राप्त रुचियां",
        sentInterests: "भेजी गई रुचियां",
        matches: "पारस्परिक जोड़ियां",
      },
      referralTitle: "दोस्तों को आमंत्रित करें और कमाएं",
      referralDesc: "अपने दोस्तों के साथ अपना रेफरल लिंक साझा करें और उनके प्रोफाइल पूरा करने पर प्रीमियम फीचर्स अनलॉक करें।",
      refCode: "आपका रेफरल कोड",
      shareWhatsapp: "व्हाट्सएप पर साझा करें",
      points: "अंक",
      rank: "रैंक",
      notifications: "हाल के अपडेट",
      markAllRead: "सभी को पढ़ा हुआ चिह्नित करें",
      noNotifications: "कोई नया अपडेट नहीं",
    }
  }
};
